import { Modalable, ResponseStatus } from './modalable';
import { WhiteboardDrawing } from './whiteboard-drawing';

export class ModalableWhiteboardVideo extends WhiteboardDrawing implements Modalable {
    static MODAL_ID = 'whiteboardVideoModal';
    status: ResponseStatus;

    getStatus(): ResponseStatus {
        return this.status;
    }

    getModalId(): string {
        return ModalableWhiteboardVideo.MODAL_ID;
    }

    canBypassCheck(): boolean {
        return true;
    }

    asWhiteboardDrawing(): WhiteboardDrawing {
        return this;
    }
}
